module.exports = __webpack_public_path__ + "images/shop/favicon-kfz24/apple-touch-icon.png";